/**
 *
 * Asynchronously loads the component for HQ
 *
 */

import { lazyLoad } from 'utils/loadable';

export const HQ = lazyLoad(
  () => import('./index'),
  module => module.HQ,
);